import { Injectable, signal } from '@angular/core'
import { NgbDatepickerI18n, NgbDateStruct } from '@ng-bootstrap/ng-bootstrap'

export type Lang = 'en' | 'fr'

const I18N: Record<Lang, { weekdays: string[]; months: string[]; monthsShort: string[];}> = {
    en: {
        weekdays: ['Mo', 'Tu', 'We', 'Th', 'Fr', 'Sa', 'Su'],
        months: [
            'January', 'February', 'March', 'April', 'May', 'June',
            'July', 'August', 'September', 'October', 'November', 'December'
        ],
        monthsShort: [
            'Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun',
            'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'
        ]
    },
    fr: {
        weekdays: ['Lu', 'Ma', 'Me', 'Je', 'Ve', 'Sa', 'Di'],
        months: [
            'Janvier', 'Février', 'Mars', 'Avril', 'Mai', 'Juin',
            'Juillet', 'Août', 'Septembre', 'Octobre', 'Novembre', 'Décembre'
        ],
        monthsShort: [
            'Jan', 'Fév', 'Mar', 'Avr', 'Mai', 'Jun',
            'Jul', 'Aoû', 'Sep', 'Oct', 'Nov', 'Déc'
        ]
    }
}

@Injectable({ providedIn: 'root' })
export class DatepickerService extends NgbDatepickerI18n 
{
    private _lang: Lang = 'en';

    get lang(): Lang { return this._lang; }

    setLang(lang: Lang): void 
    {
        this._lang = lang;
    }

    getWeekdayLabel(weekday: number): string 
    {
        return I18N[this._lang].weekdays[weekday - 1];
    }

    getMonthShortName(month: number): string 
    {
        return I18N[this._lang].monthsShort[month - 1];
    }

    getMonthFullName(month: number): string 
    {
        return I18N[this._lang].months[month - 1];
    }

    getDayAriaLabel(date: NgbDateStruct): string 
    {
        return `${date.day} ${I18N[this._lang].months[date.month - 1]} ${date.year}`;
    }
}